<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row class="mb-5" align="center" justify="center">
        <v-col>
          <h3>Consolidação de Notas de Pedidos - WireCard</h3>
        </v-col>
        <v-col class="text-right">
          <v-btn color="green" depressed dark :href="download" target="_blank" class="mr-2">
            <v-icon class="mr-2">mdi-down</v-icon>Download Tabela Exemplo
          </v-btn>
          <v-btn color="primary" depressed dark @click="dialog = true">
            Nova
          </v-btn>
        </v-col>
        <v-col cols="3">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="true"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Filtrar Mês de Referência"
                prepend-icon="mdi-calendar"
                readonly
                outlined
                dense
                hide-details
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" type="month" no-title scrollable @change="loadTotals" locale="pt-br"> </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn 
            depressed 
            color="primary" 
            class="text-center mr-1" 
            :disabled="!items.length"
            :dark="items.length" 
            @click="downloadCSV()" 
            block
          >
            <v-icon small class="mx-2">mdi-magnify</v-icon>
            Exportar CSV
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="my-3"></v-divider>

      <v-data-table :items="items" :headers="headers" :loading="loading">
        <template v-slot:[`item.orderSellerStatus`]="{ item }" class="justify-center">
          <v-chip label :color="getColor(item.orderSellerStatus)" dark>{{ getStatusSeller(item.orderSellerStatus) }}</v-chip>
        </template>

        <template v-slot:[`item.observation`]="{ item }">
          <v-text-field v-model="item.observation" @change="updateObs(item)" dense hide-details></v-text-field>
        </template>
      </v-data-table>
    </v-card>

    <TheDialog v-model="dialog" title="Nova Consolidação" width="1000px" icon="mdi-card-bulleted-outline">
      <template>
        <v-container>
          <v-form ref="form">
            <b> Nota Fiscal </b>
            <v-file-input
              label="Escolha o Arquivo"
              placeholder="Selecione..."
              id="file"
              color="primary"
              class="my-1"
              outlined
            ></v-file-input>
          </v-form>
        </v-container>
      </template>
      <template v-slot:actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary text--white" depressed @click="save()">Salvar</v-btn>
      </template>
    </TheDialog>
  </div>
</template>

<script>
import TheDialog from '@/components/TheDialog'
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { getColor, getStatusSeller } from '@/plugins/generic.js'

export default {
  components: {
    TheDialog,
  },
  data: () => ({
    date: null,
    dialog: false,
    headers: [
      { text: 'Id', value: 'orderId' },
      { text: 'NFS WireCard', value: 'nfsWirecard' },
      { text: 'ND WireCard', value: 'ndWirecard' },
      { text: 'NFS Seller', value: 'orderNumber' },
      { text: 'Status Pedido', value: 'orderSellerStatus' },
      { text: 'Observação', value: 'observation' },
    ],
    items: [],
    loading: false,
    menu: null,
    download: '',
  }),
  methods: {
    loadTotals() {
      const url = `${baseApiUrl}/finantial/orderConsolidated`

      const d = new Date()
      let date = this.formatDate(d)
      if (this.date) {
        date = this.date
      }

      this.loading = true
      axios
        .get(url, { params: { date } })
        .then((res) => {
          this.items = res.data
          this.loading = false
        })
        .catch(showError)
    },
    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month].join('-')
    },
    getColor,
    getStatusSeller,
    save() {
      const url = `${baseApiUrl}/finantial/orderConsolidated`
      this.loading = true
      this.dialog = false
      const file = document.querySelector('#file')
      var formData = new FormData()
      formData.append('file', file.files[0])

      axios
        .post(url, formData, {
          headers: {
            'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          },
        })
        .then(() => {
          this.loading = false
          this.loadTotals()
        })
        .catch(showError)
    },
    updateObs(order) {
      const url = `${baseApiUrl}/finantial/orderConsolidated/${order.orderId}`
      const object = { observation: order.observation }
      axios
        .put(url, object)
        .then(() => {
          this.loading = false
          this.loadTotals()
        })
        .catch(showError)
    },
    downloadCSV() {
      const data = this.items
      const fileName = 'download-consolidacao-notas-pedidos-wirecard'
      const csv = this.convertArrayOfObjectsToCSV(data)
      const link = document.createElement('a')
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      link.download = fileName + '.csv'
      link.click()
    },
    convertArrayOfObjectsToCSV(data) {
      const columnDelimiter = ','
      const lineDelimiter = '\n'
      const keys = Object.keys(data[0])

      let result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach((item) => {
        let ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },
  },
  mounted() {
    this.download = `${this.$router.options.base}exemploNotasWirecard.csv`
    this.loadTotals()
  },
}
</script>

<style></style>
